/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import { withTheme } from 'common/styling/theme';
import classNames from 'classnames';
import ReactDOM from 'react-dom';
import { FormattedMessage as FM } from 'react-intl';
import useOutsideClick from 'hooks/useOutsideClick';
import { Calendar } from 'common/components';
import { getCurrentDayRange } from 'crm/_newComponents/FastFilters/helpers';
import IconTrash from 'crm/_components/BaseIconButton/icons/iconTrash';

import { staticStyles, getDynamicStyles } from './style';

const DropDown = ({
  optionsRightRef,
  isOpen,
  options,
  setIsOpen,
  position,
  isCalendarOutsideOfWindow,
  windowWidth,
  selectebleOptions,
  onSelect,
  withResetButton,
  theme,
}) => {
  if (!isOpen || !Array.isArray(options)) return null;

  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;

  const handleOutSideClick = () => {
    setIsOpen(false);
  };

  useOutsideClick(optionsRightRef, handleOutSideClick);

  const portalStyle = {
    position: 'absolute',
    top: position.top + position.height,
    left: position.left,
    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.2)',
    zIndex: 9999,
    width: '200px',
  };

  const handleDateReset = () => {
    onSelect({ label: 'justAll', computedLabel: 'justAll', value: getCurrentDayRange(), isSelected: true });
    setIsOpen(false);
  };

  return ReactDOM.createPortal(
    <div style={portalStyle} className="congratulations-portal">
      <div
        ref={optionsRightRef}
        className={classNames('DateSelector__Options', {
          'DateSelector__Options--OutOfRange': isCalendarOutsideOfWindow && windowWidth >= 600,
          'DateSelector__Options--Mobile': windowWidth < 600,
        })}>
        <div className="DateSelector__OptionsLeft">
          {selectebleOptions.map(({ value, label, isSelected }) => (
            <button
              key={`DateSelector-options-${label}`}
              className={classNames('DateSelector__Option DateSelector__Option--FastFilter', {
                'DateSelector__Option--FastFilterIsSelected': isSelected,
              })}
              type="button"
              onClick={() => {
                onSelect({ value, label });
                setIsOpen(!isOpen);
              }}>
              <FM id={label}>{txt => txt}</FM>
            </button>
          ))}
        </div>
        <div className="DateSelector__OptionsRight">
          <FM id="justChooseCustomRange">{txt => <span className="DateSelector__OptionsRightTitle">{txt}</span>}</FM>
          <Calendar
            setCorrectLastDay
            daysLimit={1000}
            isUnix={false}
            onChangeFunc={(...value) => {
              onSelect({ value: value.map(val => val.valueOf()), label: 'justCustomRange' });
              setIsOpen(!isOpen);
            }}
          />
          {withResetButton && (
            <button className="DateSelector__reset-btn" type="button" onClick={handleDateReset}>
              <IconTrash />
              <FM id="justReset" />
            </button>
          )}
        </div>
      </div>
      <style jsx>{staticStyles}</style>
      <style jsx>{dynamicStyles}</style>
    </div>,
    document.body
  );
};

export default withTheme()(DropDown);
